<template>
  <component-wrapper>
    <div class="teaser-big-image-fi">
      <teaser-big-image-element-fi :fields="fields" />
    </div>
  </component-wrapper>
</template>

<script setup lang="ts">
import ComponentWrapper from 'components/component-wrapper/ComponentWrapper.vue';
import TeaserBigImageElementFi from 'components/teaser/teaser-big-image-element-fi/TeaserBigImageElementFi.vue';

withDefaults(
  defineProps<{
    fields?: any;
  }>(),
  {
    fields: () => ({}),
  },
);
</script>
